import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import AuthService from '../../services/AuthService';

function PrivateRoute({
  component: Component, path, isLoggedIn, permission,
}) {
  return (
    <Route
      exact
      path={path}
      render={() => (isLoggedIn ? (
        AuthService.canDo(permission)
          ? <Component />
          : (
            <Redirect
              to="403"
            />
          )
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: window.location.pathname },
          }}
        />
      ))}
    />
  );
}

PrivateRoute.propTypes = {
  component: PropTypes.func,
  path: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  permission: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PrivateRoute;
